export default ({ dodone }) => {
  if (!dodone || !dodone.isIgnored) return null

  return (
    <div className="red-transparent-box p-d frow items-center gap-2 text-sm mb-d">
      Ignored like it was nothing
      <i className="ph ph-smiley-sad" />
    </div>
  )
}
